<div  class="ui-g" style="background: inherit;">
	<app-report-cell *ngFor="let cell of rowData; let i = index" [CellData]="cell" class="{{getCellClass(cell, i)}}"></app-report-cell>
</div>
